import DateTimeUtils from 'utils/dateUtils';
import DateTimeFormat from 'enums/DateTimeFormat';

export interface IDateFormattingOptions {
  dateFormat?: string;
  utc?: boolean;
}

const formatDateValue = (
  value: string | Date | number,
  options: IDateFormattingOptions = {},
) => {
  const date = options?.utc ? DateTimeUtils.parseUtcUnsafe(value) : DateTimeUtils.parseUnsafe(value);

  return date.format(options?.dateFormat || DateTimeFormat.UsShortWithSlashes);
};

export default formatDateValue;
